export default function selectHours(locations, providerHours) {
  const getClosestLocation = locations.find(loc => loc.is_closest);
  const closestLocationHours = getClosestLocation?.hours;
  const organizationHours = providerHours ?? {};
  return closestLocationHours ?? organizationHours;
}
//# sourceMappingURL=selectHours.js.map